import {
  SET_LEAVE_DAYS,
  FETCH_LEAVE_DAYS_SUCCESS,
  FETCH_LEAVE_DAYS_FAILURE,
} from "./actionTypes"

const initialState = {
  leaveDays: [],
  error: null,
}

const clinicSettingReducer = (state = initialState, action) => {
  // console.log("reducer receive action",action)
  switch (action.type) {
    case SET_LEAVE_DAYS:
    case FETCH_LEAVE_DAYS_SUCCESS:
      return {
        ...state,
        // leaveDays: action.payload,
        leaveDays: Array.isArray(action.payload) ? action.payload : [],
        error: null,
      }
    case FETCH_LEAVE_DAYS_FAILURE:
      return {
        ...state,
        error: action.payload,
      }
    default:
      return state
  }
}

export default clinicSettingReducer
